function addItem(form_id) {
    var product_id       = document.querySelectorAll('#' + form_id + ' input#prodid')[0].value;
    var product_quantity = document.querySelectorAll('#' + form_id + ' input#quantity')[0].value;
    var ajaxcall         = new XMLHttpRequest();
    var json_string      = '{"items":[{"id":"'+product_id+'","quantity":"'+product_quantity+'"}]}';
    
    if (ajaxcall) {
      ajaxcall.open("POST", '/cart/add.js');
      ajaxcall.setRequestHeader("Content-Type", "application/json");
      ajaxcall.onreadystatechange = function() {
        if (this.readyState == 4 && this.status == 200) {
          document.dispatchEvent(new CustomEvent('cart:build'));
          document.dispatchEvent(new CustomEvent('cart:open'));
        }
      }
    } else {
      console.log('Giving up :( Cannot create an XMLHTTP instance');
      return false;
    }
    ajaxcall.send(json_string);
  }
  